
export const FETCH_STONES_REQUEST = 'FETCH_STONES_REQUEST';
export const FETCH_STONES_SUCCESS = 'FETCH_STONES_SUCCESS';
export const FETCH_STONES_FAILURE = 'FETCH_STONES_FAILURE';

export const CREATE_STONE = 'CREATE_STONE';
export const UPDATE_STONE = 'UPDATE_STONE';
export const DELETE_STONE = 'DELETE_STONE';
